module.exports = __webpack_public_path__ + "img/search_icon.79671024.svg";